<template>
    <el-dialog title="您的身份" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-identify">
        <img src="../assets/images/tuoyuan.png" alt="背景图" class="dialog-img">
        <el-row :gutter="20">
            <el-col :span="8">
                <div class="grid-content">
                    <img src="../assets/images/jz.png" alt="家长">
                    <div>家长</div>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content">
                    <img src="../assets/images/stu.png" alt="学生">
                    <div>学生</div>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content">
                    <img src="../assets/images/teacher.png" alt="老师">
                    <div>老师</div>
                </div>
            </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="{}">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "Identity",
    data() {
        return {
        };
    },
    computed: {
    },
    methods: {
    }
}
</script>

<style lang='scss' scoped>
.dialog-box {
    .grid-content {
        height: 160px;
        width: 152px;
        border: 1px solid #e1e4eb;
        border-radius: 9px;
        text-align: center;
        position: relative;
        z-index: 999;
        background: #fff;
    }
    img {
        width: 68px;
        height: 68px;
        margin-bottom: 27px;
        margin-top: 28px;
    }
}
.dialog-footer {
    padding: 0;
    button {
        width: 496px!important;
        height: 52px;
        background: linear-gradient(270deg,#3272ff, #60aaff 99%)!important;
        border-radius: 8px;
        margin: 0 auto;
        font-size: 18px!important;
        margin-top: 15px;
        color: #ffffff!important;
    }
    }
</style>